import React from "react";
import { Embed } from "semantic-ui-react";

export default function ForecastVideo(){
    return (
         <div style={{overflowX:"auto"}}>
         </div>
    );
}